/**
 * Created by ShaunBetts on 23-Apr-16.
 */

import Vue from 'vue';

import {ERROR} from 'module/constants';

import common from 'module/common';

const SOCKET_ERROR = 'SOCKET_ERROR';

// initial state
const state = {
  errors: [],
  errorsByType: {
    socket: []
  },
  currentError: null
};

//actions
const actions = {
  error({commit}, payload) {
    commit('error', payload)
  },
  clear({commit}, payload) {
    commit('clear', payload)
  },
  socket({commit}, payload) {
    commit('socket', payload)
  },
  report({rootGetters}, {err, entity}){
    let data = {
      idToken: rootGetters['user/idToken'](),
      message: err.message,
      stack: err.stack,
      entity: entity
    };

    common
      .httpPost('portal/reportError')
      .data(data)
      .then((res) => {
        console.log('Error Reported');
      }, (err) => {
        console.log('Error Reporting Error (how ironic)', err);
      });
  },
};

//getters prawns
const getters = {

};

// mutations
const mutations = {
  error (state, error) {
    error = error.get();
    state.errors.push(error);

    //get existing and add to errors for type
    let errorForType = state.errorsByType[error.type] || [];
    errorForType.push(error);

    Vue.set(state.errorsByType, error.type, errorForType);

    if(error.notifyUser !== false){
      state.currentError = error;
    }
  },
  clear (state) {
    state.currentError = null;
  },
  socket (state, error) {
    state.errors.push(error);
    state.errorsByType.socket.push(error);
    state.currentError = error;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}
